module.exports = __webpack_public_path__ + "img/xxlj_icon_1.4b33f436.svg";